import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { TextContext } from '@/utils/contexts/TextContext';
import { ModalContext } from '@/utils/contexts/ModalContext';
import api from '@/services/api';

import styles from '@/views/pages/Letter/elements/LetterContinueSimplificationBar.module.scss';

const LetterContinueSimplificationBar = () => {
	const { dict } = useSelector((state) => state.app);
	const { contextState } = useContext(TextContext);
	const { showModal } = useContext(ModalContext);
	const navigate = useNavigate();

	return (
		<div className={ styles['continue-simplification-bar'] }>
			<span className={ styles['continue-simplification-bar--left-text'] }>{dict.letter.continueSimplificationBar.text1}</span>
			<span className={ styles['continue-simplification-bar--right-text'] }>{dict.letter.continueSimplificationBar.text2}</span>
			<div
				className='button__blue'
				onClick={ () => {
					if (contextState.letterData.letterTemplateId) {
						showModal({
							componentName: 'ModalContinueSimplification',
							additionalInfo: {
								id: contextState.letterData.id,
							},
						});
					} else {
						api.put(`/letters/${contextState.letterData.id}/simplified`).then(() => {
							navigate(0);
						});
					}
				} }
			>
				{dict.letter.continueSimplificationBar.button}
			</div>
		</div>
	);
};
export default React.memo(LetterContinueSimplificationBar);